<template>
  <div class="TodayPlanWrap ashComWrap">
    <div class="comTitle">
      <h4>今日计划</h4>
      <ul class="planUl">
        <li v-for="v in planMenu"
          :key="v.key"
          @click="planActive = v.key"
          :style="{ color: planActive == v.key ? '#28CCCB' : '#666' }">
          {{ v.name }}
        </li>
      </ul>
    </div>
    <div class="comContentBox">
      <PlanTable :planActive="planActive"
        v-if="planMenu.length" />
      <el-empty v-else
        description="暂无计划"></el-empty>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import PlanTable from "@/components/gongzuotai/PlanTable";
export default {
  components: {
    PlanTable,
  },
  data() {
    return {
      planActive: "",
      planMenu: [],
    };
  },
  methods: {
    async getPlanList() {
      let res = await api.controlGetPlanList({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        key: "Plans",
      });
      if (res && res.data.code == 200) {
        this.planMenu = res.data.data;
        this.planActive = this.planMenu[0]?.key;
      }
    },
  },
  created() {
    this.getPlanList();
  },
};
</script>

<style lang="scss" scoped>
.TodayPlanWrap {
  width: 100%;
  height: 100%;
  .planUl {
    @include setFlexStart;
    li {
      margin-right: 10px;
      cursor: pointer;
    }
    li:hover {
      color: rgb(40, 204, 203) !important;
    }
  }
}
</style>